
import { RevBreadcrumb } from '@ds/components/Breadcrumb'
import { RevButton } from '@ds/components/Button'
import { RevContainer } from '@ds/components/Container'
import { RevDivider } from '@ds/components/Divider'
import { RevLink } from '@ds/components/Link'
import { RevRating } from '@ds/components/Rating'
import { IconQuality } from '@ds/icons/IconQuality'
import isEmpty from 'lodash/isEmpty'

import { createObserver } from '@core/helpers/vue-Intersection-observer'
import FormattedMessage from '@i18n/components/FormattedMessage'
import Tags from '@product/components/Tags'
import { ROUTES } from '@router'
import { trackClick, trackReviewBlockImpression } from '@tracking/events'

import FrequentSearches from '../FrequentSearches'
import RateSort from '../RateSort'
import { RATE_SORT_TYPE } from '../RateSort/RateSort.constants'
import ReviewsLegalModal from '../ReviewsLegalModal'
import RateFilter from '../legacy/RateFilter'
import ReviewsList from '../legacy/ReviewsList'

import translations from './Page.translations'
import RatingCategories from './components/RatingCategories'
import {
  REVIEWS_LIST_ID,
  SEO_TEXT_DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
  TRACKING_ZONE,
} from './constants'

export default {
  components: {
    RateSort,
    RevLink,
    RevButton,
    FrequentSearches,
    RevBreadcrumb,
    RevContainer,
    RevDivider,
    FormattedMessage,
    RatingCategories,
    RateFilter,
    RevRating,
    ReviewsList,
    Tags,
    IconQuality,
    ReviewsLegalModal,
  },
  props: {
    breadcrumb: {
      type: Array,
      required: true,
    },
    globalRate: {
      type: Number,
      default: 0,
    },
    isMaxReviewsReached: {
      type: Boolean,
      default: false,
    },
    ratingCategories: {
      type: Array,
      default: () => [],
    },
    reviews: {
      type: Array,
      required: true,
    },
    statsInfo: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: String,
      default: '',
    },
    tags: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    totalReviews: {
      type: Number,
      default: null,
    },
    type: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hideSeoText: true,
    }
  },
  computed: {
    ROUTES: () => ROUTES,
    RATE_SORT_TYPE: () => RATE_SORT_TYPE,
    REVIEWS_LIST_ID: () => REVIEWS_LIST_ID,
    translations: () => translations,
    dataSelectorAttribute: () => SEO_TEXT_DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
    trackingInfo() {
      return {
        zone: TRACKING_ZONE,
        pageType: this.$route.name,
      }
    },
    productUrl() {
      return this.breadcrumb[1]?.slug
    },
    dynamicContentForAllReviews() {
      return {
        title: this.$t(translations.titleNeutral),
        dynamicContent: this.$t(translations.allProducts),
      }
    },
    dynamicContentForMerchantReviews() {
      return {
        title: this.$t(translations.titleMerchant, {
          merchant: this.title || this.type.sellerSlug,
        }),
        dynamicContent: '',
      }
    },
    dynamicContentForProductReviews() {
      return {
        title: this.$t(translations.titleProduct, {
          productName: this.title,
        }),
        dynamicContent: '',
      }
    },
    dynamicContentForLandingReviews() {
      return {
        title: this.$t(translations.titleNeutral),
        dynamicContent: this.title || this.type.landingSlug,
      }
    },
    getTitleConfigFromPage() {
      switch (this.type.name) {
        case ROUTES.REVIEWS.PAGES.LANDING:
          return this.dynamicContentForLandingReviews
        case ROUTES.REVIEWS.PAGES.MERCHANT:
          return this.dynamicContentForMerchantReviews
        case ROUTES.REVIEWS.PAGES.PRODUCT:
          return this.dynamicContentForProductReviews
        case ROUTES.REVIEWS.PAGES.ALL:
        default:
          return this.dynamicContentForAllReviews
      }
    },
    titlePage() {
      return `${this.getTitleConfigFromPage.title} ${this.getTitleConfigFromPage.dynamicContent}`
    },
    isGlobalReview() {
      return this.type.name === ROUTES.REVIEWS.PAGES.ALL
    },
    isLandingReview() {
      return this.type.name === ROUTES.REVIEWS.PAGES.LANDING
    },
    hasBackButton() {
      return (
        this.type.name === ROUTES.REVIEWS.PAGES.PRODUCT &&
        !isEmpty(this.productUrl)
      )
    },
    hasTags() {
      return !isEmpty(this.tags)
    },
    hasRateFilter() {
      return !isEmpty(this.statsInfo)
    },
    hasRatingCategories() {
      return !isEmpty(this.ratingCategories)
    },
    hasRatingCategoriesOrSEOText() {
      return this.hasRatingCategories || this.isGlobalReview
    },
  },

  mounted() {
    this.watchReviewInViewport()
  },
  destroyed() {
    if (typeof this.unobserve === 'function') {
      this.unobserve()
    }
  },
  methods: {
    watchReviewInViewport() {
      this.unobserve = createObserver(this.$el, () => {
        trackReviewBlockImpression({
          ...this.trackingInfo,
          averageRate: this.globalRate,
          reviewsCount: this.totalReviews,
        })
      })
    },
    trackClickEvent(name) {
      trackClick({
        ...this.trackingInfo,
        name,
      })
    },
  },
}
